import { MessageCircle } from "lucide-react"
import Comment from "./Comment"

// Comments Section Component
const CommentsSection = ({ comments, onDeleteComment, totalComment }) => {
    const parentComments = comments.filter(c => !c.parentCommentId)
    const childComments = comments.filter(c => c.parentCommentId)

    return (
        <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6">
            <h2 className="text-xl font-bold text-gray-900 mb-6">
                Comments ({Math.abs(totalComment)})
            </h2>
            
            <div>
                {parentComments.map((comment) => (
                    <Comment 
                        key={comment._id} 
                        comment={comment}
                        replies={childComments}
                        onDeleteComment={onDeleteComment}
                    />
                ))}
            </div>

            {comments.length === 0 && (
                <div className="text-center py-8 text-gray-500">
                    <MessageCircle className="w-12 h-12 mx-auto mb-3 opacity-30" />
                    <p>No comments yet. Be the first to comment!</p>
                </div>
            )}
        </div>
    )
}

export default CommentsSection;